import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RicercaGenericaAnagraficheComponent } from './ricerca-generica-anagrafiche.component';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';

@NgModule({
  declarations: [RicercaGenericaAnagraficheComponent],
  imports: [
    CommonModule, 
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CustomFormControlsModule,
  ],
  exports: [RicercaGenericaAnagraficheComponent],
})
export class RicercaGenericaAnagraficheModule { }
